import React from 'react';
import classnames from 'classnames';
import { isImageProps, ImageType } from '../../utils/is-image-props';

import styles from './avatar.module.scss';

export type AvatarType = {
  content: ImageType | string;
  'aria-label'?: string;
  className?: string;
} & Pick<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>;

const renderContent = (content: ImageType | string) => {
  if (isImageProps(content)) {
    return <img src={content.src} alt={content.alt} />;
  }

  return <span>{content}</span>;
};

export const Avatar: React.FC<AvatarType> = ({ content, onClick, className, 'aria-label': ariaLabel }) => {
  const classes = classnames(styles.avatar, { [styles.clickable]: onClick }, className);

  const baseProps = {
    className: classes,
    'data-testid': 'avatar-component',
    children: content && renderContent(content),
    'aria-label': ariaLabel
  };

  if (onClick) {
    return <button {...baseProps} onClick={onClick} />;
  }
  return <div {...baseProps} />;
};
